import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import Modal from "components/Modal";
import NumberFormats from "components/NumberFormats";
import { LoadingButton } from "@mui/lab";
import useIsMobileView from "hooks/useIsMobileView";
import useDispatch from "hooks/useDispatch";
import {
  investmentPortfolioBuy,
  getInvestmentPortfolioCurrentlyList,
  getInvestmentPortfolioCurrentlyInfo,
} from "store/slices/investment/investmentSlice";
import { useState } from "react";

export default function OrderConfirmationModal({
  open,
  onClose,
  investment,
  amount,
  handleClickShowMore,
}) {
  const [loading , setLoading] = useState(false)

  const dispatch = useDispatch();

  const isMobileView = useIsMobileView();

  const investmentPortfolio = investment?.objPortfolio;
  

  const onSubmit = async () => {
    setLoading(true)
    
    const body = {
      id: investmentPortfolio?.id,
      amount: amount,
      typeId: investment?.typeId
    };

    await dispatch(
      investmentPortfolioBuy(body),
      "درخواست شما با موفقیت ارسال شد"
    );

    dispatch(getInvestmentPortfolioCurrentlyInfo());
    await dispatch(getInvestmentPortfolioCurrentlyList());
    
    setLoading(false)
    onClose();
    handleClickShowMore();
  };

  return (
    <Modal
      maxWidth={"xs"}
      onClose={onClose}
      open={open}
      title="Order Confirmation"
      dir="ltr"
    >
      <Box px={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} pb={2}>
            <Typography color="text.main" variant="h5" fontWeight={400} pt={2}>
              <Typography
                color="text.alternate"
                variant={isMobileView ? "h6" : "h5"}
                component="span"
                pr={0.5}
              >
                {amount}
                {" "}
                {investmentPortfolio?.baseCoinName}
              </Typography>
              Will Be Transferred From Your Spot Wallet To Your Investment Fund
              Wallet.
            </Typography>
          </Grid>

          <Divider width={"100%"} />

          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" pb={1} pt={2}>
              <Typography variant="h6" color="text.secondary" fontWeight={400}>
                Amount
              </Typography>
              <Box display="flex">
                <Typography variant="h5" color="text.main" fontWeight={400}>
                  <NumberFormats value={amount} />
                </Typography>
                <Typography
                  variant="h6"
                  color="text.secondary"
                  fontWeight={400}
                  pl={0.5}
                >
                  {investmentPortfolio?.baseCoinName}
                </Typography>
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" pb={3}>
              <Typography variant="h6" color="text.secondary" fontWeight={400}>
                Fee
              </Typography>
              <Box display="flex">
                <Typography variant="h5" color="text.main" fontWeight={400}>
                  <NumberFormats
                    value={investmentPortfolio?.feePercentageBuy}
                  />
                </Typography>

                <Typography
                  variant="h6"
                  color="text.secondary"
                  fontWeight={400}
                  pl={0.5}
                >
                  %
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3} px={0}>
              <Grid item xs={6}>
                <Button color="info" fullWidth onClick={onClose}>
                  Cancel
                </Button>
              </Grid>

              <Grid item xs={6}>
                <LoadingButton
                  variant="contained"
                  type="submit"
                  fullWidth
                  color="success"
                  loading={loading}
                  onClick={onSubmit}
                >
                  Confirm
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
